import React from "react";
import { LayoutList, Users, BarChart3 } from "lucide-react";

const tabs = [
    { id: "list", label: "Task list", shortLabel: "List", icon: LayoutList },
    { id: "assignments", label: "By assignee", shortLabel: "Team", icon: Users },
    { id: "analytics", label: "Analytics", shortLabel: "Stats", icon: BarChart3 },
];

const TaskViewTabs = ({ active, onChange }) => (
    <div
        className="flex gap-1 p-1 rounded-xl bg-surface-2 border border-line overflow-x-auto scrollbar-hide"
        role="tablist"
        aria-label="Task views"
    >
        {tabs.map(({ id, label, shortLabel, icon: Icon }) => (
            <button
                key={id}
                type="button"
                role="tab"
                aria-selected={active === id}
                onClick={() => onChange(id)}
                className={`flex-1 min-w-[88px] flex items-center justify-center gap-1.5 px-2 sm:px-3 py-2 rounded-lg text-xs font-semibold transition min-h-[44px] sm:min-h-[40px] ${
                    active === id
                        ? "bg-primary text-primary-contrast shadow-sm"
                        : "text-ink-secondary hover:text-ink hover:bg-surface-3"
                }`}
            >
                <Icon size={14} className="shrink-0" />
                <span className="sm:hidden">{shortLabel}</span>
                <span className="hidden sm:inline">{label}</span>
            </button>
        ))}
    </div>
);

export default TaskViewTabs;
